import { createIcon } from '@chakra-ui/react';

export const CheckShield = createIcon({
  displayName: 'Shield Check',
  viewBox: '0 0 21.427 24',
  path: (
    <path
      id="Shield_Check_-_L-2"
      data-name="Shield Check - L"
      d="M24.742,4.9a.568.568,0,0,0-.568.564V15.508c0,3.429-6.739,6.724-9.593,7.825-2.85-1.143-9.57-4.572-9.57-7.825V4.014l9.581-2.366L24.6,4.121a.565.565,0,0,0,.274-1.1L14.711.517a.648.648,0,0,0-.27,0L4.307,3.024a.564.564,0,0,0-.427.549V15.508c0,4.8,10.061,8.8,10.488,8.957a.56.56,0,0,0,.206.038.587.587,0,0,0,.2-.034,34.885,34.885,0,0,0,5.177-2.514c3.554-2.133,5.356-4.3,5.356-6.446V5.466a.564.564,0,0,0-.564-.564ZM18.5,9.176l-5.433,5.459-2.392-2.358a.566.566,0,0,0-.792.808l2.8,2.751a.571.571,0,0,0,.381.16.564.564,0,0,0,.4-.164L19.3,9.972a.564.564,0,1,0-.8-.8Z"
      transform="translate(-3.88 -0.503)"
      fill="currentColor"
    />
  ),
});
